const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-ReadOnly',
			Template: /*HTML*/`
			<!-- InputType ReadOnly {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
				<div class="field has-addons has-addons-right mb-0">
					<p class="control is-expanded">
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							class="input {~ColumnAlignment:Record~}"
							{~D:Record.Macro.ControlAttr~}
							type="{~D:Record.DataType~}"
							{~D:Record.Macro.InputFullProperties~}
							readonly
							disabled
							tabindex="-1"
							value=""
						/>
					</p>
					{~UnitsAddon:Record~}
				</div>
				<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-ReadOnly',
			Template: /*HTML*/`
			<!-- InputType ReadOnly {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field has-addons has-addons-right mb-0">
							<p class="control is-expanded">
								<input
									id="{~D:Record.Macro.RawHTMLID~}"
									class="input {~ColumnAlignment:Record~}"
									{~D:Record.Macro.ControlAttr~}
									type="{~D:Record.DataType~}"
									{~D:Record.Macro.InputFullProperties~}
									readonly
									disabled
									tabindex="-1"
									value=""
								/>
							</p>
							{~UnitsAddon:Record~}
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-ReadOnly',
			Template: /*HTML-Partial*/`
			<!-- DataType Text {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field has-addons has-addons-right mb-0">
				<p class="control is-expanded">
					<input
						id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						class="input {~ColumnAlignment:Record~}"
						{~D:Record.Macro.ControlAttr~}
						type="{~D:Record.DataType~}"
						{~D:Record.Macro.HTMLName~}
						{~D:Record.Macro.InformaryTabular~}
						readonly
						disabled
						tabindex="-1"`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-ReadOnly',
			Template: /*HTML-Partial*/`
					/>
				</p>
				{~UnitsAddon:Record~}
			</div>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-ReadOnly',
			Template: /*HTML*/`
			<!-- InputType ReadOnly {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
				<div class="field has-addons has-addons-right mb-0">
					<p class="control is-expanded">
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							{~D:Record.Macro.ControlAttr~}
							type="{~D:Record.DataType~}"
							class="input {~ColumnAlignment:Record~}"
							readonly
							aria-readonly="true"
							{~D:Record.Macro.InputFullProperties~}
							value=""
							tabindex="-1"
						/>
					</p>
					{~UnitsAddon:Record~}
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-ReadOnly',
			Template: /*HTML*/`
			<!-- InputType ReadOnly {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field">
							<p class="control">
								<input
									id="{~D:Record.Macro.RawHTMLID~}"
									{~D:Record.Macro.ControlAttr~}
									type="{~D:Record.DataType~}"
									class="input {~ColumnAlignment:Record~}"
									readonly
									aria-readonly="true"
									{~D:Record.Macro.InputFullProperties~}
									value=""
									tabindex="-1"
								/>
							</p>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-ReadOnly',
			Template: /*HTML-Partial*/`
			<!-- DataType Text {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field has-addons has-addons-right mb-0">
				<p class="control is-expanded">
					<input
						id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						{~D:Record.Macro.ControlAttr~}
						type="{~D:Record.DataType~}"
						class="input {~ColumnAlignment:Record~}"
						readonly
						aria-readonly="true"
						{~D:Record.Macro.HTMLName~}
						{~D:Record.Macro.InformaryTabular~}
						tabindex="-1"`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-ReadOnly',
			Template: /*HTML-Partial*/`
						value=""
					/>
				</p>
				{~UnitsAddon:Record~}
			</div>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-ReadOnly',
			Template: /*HTML*/`
			<!-- InputType ReadOnly {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~} {~HideInPDF:Record~}">
				<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
				<div class="field has-addons has-addons-right mb-0">
					<div class="control is-expanded">
						<div
							id="{~D:Record.Macro.RawHTMLID~}"
							class="input is-static {~ColumnAlignment:Record~}"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.InputFullProperties~}
						></div>
					</div>
					{~UnitsAddonPrint:Record~}
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-ReadOnly',
			Template: /*HTML*/`
			<!-- InputType ReadOnly {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-1 {~HideInPDF:Record~}">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field has-addons has-addons-right mb-0">
							<div class="control is-expanded">
								<div
									id="{~D:Record.Macro.RawHTMLID~}"
									class="input is-static {~ColumnAlignment:Record~}"
									{~D:Record.Macro.ControlAttr~}
									{~D:Record.Macro.InputFullProperties~}
								></div>
							</div>
							{~UnitsAddonPrint:Record~}
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-ReadOnly',
			Template: /*HTML-Partial*/`
			<!-- DataType Text {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field has-addons has-addons-right mb-0">
				<div class="control is-expanded">
					<div
						id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						class="input is-static {~ColumnAlignment:Record~}"
						{~D:Record.Macro.ControlAttr~}
						readonly
						{~D:Record.Macro.HTMLName~}
						{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-ReadOnly',
			Template: /*HTML-Partial*/`
					></div>
				</div>
				{~UnitsAddonPrint:Record~}
			</div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;
